import { ActionKitBuilder } from '../action-kit';
import type {
  ActionKitImpAction,
  ActionKitImpErrorDefault,
  InferActionKitImpTypes,
} from './types';
import { unauthenticatedErrorMapper } from './actionKitImpErrorMappers';

export function actionKitImpBuilder<T extends (...args: any[]) => Promise<any>>(
  fn: T,
): ActionKitBuilder<
  InferActionKitImpTypes<T>['args'],
  InferActionKitImpTypes<T>['result'],
  ActionKitImpErrorDefault
> {
  return new ActionKitBuilder<
    InferActionKitImpTypes<T>['args'],
    InferActionKitImpTypes<T>['result']
  >(fn).onError(unauthenticatedErrorMapper);
}

export function actionKitImpFunction<
  T extends (...args: any[]) => Promise<any>
>(fn: T): ActionKitImpAction<T> {
  return actionKitImpBuilder<T>(fn).toFunction() as any;
}
